import {
  UPDATE_SEGMENTS,
  UPDATE_SEGMENT,
  UPDATE_USER,
  TOGGLE_PAYMENT_LOADER
} from './types'

export default {
  [UPDATE_SEGMENTS] (state, segments) {
    state.segments = segments
  },
  [UPDATE_SEGMENT] (state, {
    segment,
    info
  }) {
    state.segments = state.segments.map(el => {
      if (el.slug === segment) {
        return {
          ...el,
          status: 'judgment_pending',
          data: info
        }
      } else {
        return el
      }
    })
  },
  [UPDATE_USER] (state, user) {
    state.user = user
  },
  [TOGGLE_PAYMENT_LOADER] (state, toggle) {
    state.paymentLoader = toggle
  }
}
